import React from 'react';
import { Section } from './ui/Section';
import { Clock, HeartCrack, DollarSign } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <HeartCrack className="w-8 h-8 text-[#C9A84C]" data-id="element-126" />,
    title: 'Panza flácida hormonal',
    description: 'Cortisol estrés, estrógenos lactancia, core dormido. 70% mamás latinas afectado.'
  }, {
    icon: <Clock className="w-8 h-8 text-[#C9A84C]" data-id="element-127" />,
    title: 'Culpa diaria',
    description: 'Fotos pre-embarazo vs ahora. Jeans guardados. Instagram destroza (primos "fitness" 6 semanas).'
  }, {
    icon: <DollarSign className="w-8 h-8 text-[#C9A84C]" data-id="element-128" />,
    title: 'No tiempo, dinero',
    description: 'No tiempo gym, dinero suplementos. Necesitas QUÉ FUNCIONA en caos real.'
  }];
  return <Section className="bg-white" data-id="element-129">
      <div className="text-center mb-12" data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-4 font-serif" data-id="element-131">
          Eres latina 25-45 USA, 1-3 hijos posparto. <br data-id="element-132" />
          Doble jornada: casa + trabajo.
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-133">
        {problems.map((problem, index) => <div key={index} className="bg-[#FFF8F0] p-8 rounded-xl border-l-4 border-[#C9A84C] shadow-sm hover:shadow-md transition-shadow" data-id="element-134">
            <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-135">
              {problem.icon}
            </div>
            <h3 className="text-xl font-bold text-[#0D5C63] mb-3 font-serif" data-id="element-136">
              {problem.title}
            </h3>
            <p className="text-[#2D2D2D] leading-relaxed" data-id="element-137">
              {problem.description}
            </p>
          </div>)}
      </div>
    </Section>;
}